export const exteriorScenes = {
  site_view: {
    name: "Site View",
    panorama: "/images/Site_View.jpg",
    thumbnail: "/images/thumbnail/Site_View.jpg",
    defaultYaw: "120deg",
    defaultPitch: "0deg",
    hotspots: [
      // {
      //   id: "to-locality_view",
      //   yaw: "150deg",
      //   pitch: "25deg",
      //   label: "Locality View",
      //   target: "locality_view",
      //   type: "drone"
      // },
      // {
      //   id: "to-floor_5",
      //   yaw: "150deg",
      //   pitch: "0deg",
      //   label: "Floor 5",
      //   target: "floor_5",
      //   type: "drone"
      // },
      // {
      //   id: "to-floor_8",
      //   yaw: "140deg",
      //   pitch: "7deg",
      //   label: "Floor 8",
      //   target: "floor_8",
      //   type: "drone"
      // },
      // {
      //   id: "to-floor_12",
      //   yaw: "130deg",
      //   pitch: "10deg",
      //   label: "Floor 12",
      //   target: "floor_12",
      //   type: "drone"
      // },
      // {
      //   id: "to-kamalam_view",
      //   yaw: "265deg",
      //   pitch: "10deg",
      //   label: "Kamalam View",
      //   target: "kamalam_view",
      //   type: "drone"
      // },
      {
        id: "building_polygon",
        polygon: [
          ["115deg", "-13deg"], //bottom right
          ["115deg", "0deg"],
          ["152deg", "-1deg"],
          ["152deg", "-20deg"],
          ["145deg", "-25deg"],
        ],
        svgStyle: {
          fill: "rgba(37, 99, 235, 0.18)",
          stroke: "#2563EB",
          strokeWidth: 3,
        },
        type: "polygon",
      },
      {
        id: "to-site_view_1",
        yaw: "130deg",
        pitch: "-3deg",
        label: "Shreem Arise",
        target: "site_view",
        type: "point-label",
        lineHeight: 300,
        fixed: true
      },
      {
        id: "Koba Metro Station (Old)",
        yaw: "190deg",
        pitch: "0deg",
        label: "Koba Metro Station (Old)",
        type: "point-label",
        lineHeight: 190,
      },
      {
        id: "Jain Tirth Dham",
        yaw: "200deg",
        pitch: "0deg",
        label: "Jain Tirth Dham",
        type: "point-label",
        lineHeight: 150,
      },
      {
        id: "Shreem Arise Sample House",
        yaw: "170deg",
        pitch: "-20deg",
        label: "Shreem Arise Sample House",
        type: "point-label",
        lineHeight: 150,
      },
      {
        id: "Shreem Arise Office",
        yaw: "195deg",
        pitch: "-20deg",
        label: "Shreem Arise Office",
        type: "point-label",
        lineHeight: 150,
      },
      {
        id: "Koba Gam Metro Station",
        yaw: "45deg",
        pitch: "0deg",
        label: "Koba Gam Metro Station",
        type: "point-label",
        lineHeight: 110,
      },
      // {
      //   id: "Riverfront Entrance",
      //   yaw: "93deg",
      //   pitch: "-5deg",
      //   label: "Riverfront Entrance",
      //   type: "point-label",
      //   lineHeight: 150,
      // },
      {
        id: "Raksha Shakti Circle",
        yaw: "-10deg",
        pitch: "1deg",
        label: "Raksha Shakti Circle",
        type: "point-label",
        lineHeight: 90,
      },
      {
        id: "BJP Office Road",
        yaw: "-95deg",
        pitch: "-10deg",
        label: "BJP Office Road",
        type: "point-label",
        lineHeight: 90,
      },
      {
        id: "Lotus Heights",
        yaw: "-75deg",
        pitch: "4deg",
        label: "Lotus Heights",
        type: "point-label",
        lineHeight: 90,
      },
      {
        id: "SMVS - Swaminarayan Temple",
        yaw: "-1deg",
        pitch: "-1deg",
        label: "SMVS - Swaminarayan Temple",
        type: "point-label",
        lineHeight: 90,
      }
    ],
  },
  locality_view: {
    name: "Locality View",
    panorama: "/images/Locality_View.jpg",
    thumbnail: "/images/thumbnail/Locality_View.jpg",
    defaultYaw: "-20deg",
    defaultPitch: "-50deg",
    hotspots: [
      // {
      //   id: "to-site_view",
      //   yaw: "0deg",
      //   pitch: "-25deg",
      //   label: "Site View",
      //   target: "site_view",
      //   type: "drone"
      // },
      // {
      //   id: "to-floor_5",
      //   yaw: "0deg",
      //   pitch: "-60deg",
      //   label: "Floor 5",
      //   target: "floor_5",
      //   type: "drone"
      // },
      // {
      //   id: "to-floor_8",
      //   yaw: "-30deg",
      //   pitch: "-50deg",
      //   label: "Floor 8",
      //   target: "floor_8",
      //   type: "drone"
      // },
      // {
      //   id: "to-floor_12",
      //   yaw: "-10deg",
      //   pitch: "-40deg",
      //   label: "Floor 12",
      //   target: "floor_12",
      //   type: "drone"
      // },
      // {
      //   id: "to-kamalam_view",
      //   yaw: "90deg",
      //   pitch: "0deg",
      //   label: "Kamalam View",
      //   target: "kamalam_view",
      //   type: "drone"
      // },
      // {
      //   id: "to-riverfront",
      //   polygon: [
      //     ["-105deg", "-23deg"], //bottom right
      //     ["-101deg", "-15deg"],
      //     ["-99deg", "-16deg"],
      //     ["-103deg", "-24deg"],

      //   ],
      //   svgStyle: {
      //     fill: "rgb(152, 146, 139)",
      //     stroke: "rgb(183, 172, 160)",
      //     strokeWidth: 3,
      //   },
      //   type: "polygon",
      // },
      // {
      //   id: "to-riverfront-2",
      //   polygon: [
      //     ["-101deg", "-15deg"], //bottom right
      //     ["-93deg", "-11deg"],
      //     ["-93deg", "-13deg"],
      //     ["-99deg", "-16deg"],

      //   ],
      //   svgStyle: {
      //     fill: "rgb(152, 146, 139)",
      //     stroke: "rgb(183, 172, 160)",
      //     strokeWidth: 3,
      //   },
      //   type: "polygon",
      // },
      {
        id: "Riverfront Road",
        yaw: "-100deg",
        pitch: "-16deg",
        label: "Riverfront Road",
        type: "point-label",
        lineHeight: 190,
      },
      {
        id: "to-site_view_1",
        yaw: "-3deg",
        pitch: "-80deg",
        label: "Shreem Arise",
        target: "site_view",
        type: "point-label",
        lineHeight: 150,
        fixed: true
      },
      {
        id: "PDPU",
        yaw: "-140deg",
        pitch: "0deg",
        label: "PDPU",
        type: "point-label",
        lineHeight: 90,
      },
      {
        id: "Urban Primary Health Centre",
        yaw: "-142deg",
        pitch: "0deg",
        label: "Urban Primary Health Centre",
        type: "point-label",
        lineHeight: 130,
      },
      {
        id: "PDPU Circle",
        yaw: "-143deg",
        pitch: "-1deg",
        label: "PDPU Circle",
        type: "point-label",
        lineHeight: 230,
      },
      {
        id: "Mahaveer Jain Temple",
        yaw: "-160deg",
        pitch: "-2deg",
        label: "Mahaveer Jain Temple",
        type: "point-label",
        lineHeight: 230
      },
      {
        id: "Little Poppins Preschool & Daycare",
        yaw: "-155deg",
        pitch: "-3deg",
        label: "Little Poppins Preschool & Daycare",
        type: "point-label",
        lineHeight: 210
      },
      {
        id: "Little Millennium Preschool",
        yaw: "-165deg",
        pitch: "-2deg",
        label: "Little Millennium Preschool",
        type: "point-label",
        lineHeight: 250,
        direction: "right"
      },
      {
        id: "Harvi heart care hospital",
        yaw: "-175deg",
        pitch: "-2deg",
        label: "Harvi heart care hospital",
        type: "point-label",
        lineHeight: 170,
        direction: "right"
      },
      {
        id: "Uma Clinic",
        yaw: "-170deg",
        pitch: "-2deg",
        label: "Uma Clinic",
        type: "point-label",
        lineHeight: 210,
        direction: "right"
      },
      {
        id: "Swaminarayan Temple",
        yaw: "-195deg",
        pitch: "-8deg",
        label: "Swaminarayan Temple",
        type: "point-label",
        lineHeight: 60,
      },
      {
        id: "Koba Goverment School",
        yaw: "-198deg",
        pitch: "-6deg",
        label: "Koba Goverment School",
        type: "point-label",
        lineHeight: 90,
      },
      {
        id: "Koba Gam Metro Station",
        yaw: "-150deg",
        pitch: "-8deg",
        label: "Koba Gam Metro Station",
        type: "point-label",
        lineHeight: 20,
      },
      {
        id: "Gift City",
        yaw: "-130deg",
        pitch: "0deg",
        label: "Gift City",
        type: "point-label",
        lineHeight: 90,
      },
      {
        id: "Police Pared Groud",
        yaw: "-60deg",
        pitch: "-2deg",
        label: "Police Pared Groud",
        type: "point-label",
        lineHeight: 90,
      },
      {
        id: "Riverfront Bridge",
        yaw: "-35deg",
        pitch: "-2deg",
        label: "Riverfront Bridge",
        type: "point-label",
        lineHeight: 90,
      },
      {
        id: "Raksha Shakti Circle",
        yaw: "160deg",
        pitch: "0deg",
        label: "Raksha Shakti Circle",
        type: "point-label",
        lineHeight: 120,
      },
      {
        id: "BJP Office Road",
        yaw: "91deg",
        pitch: "-10deg",
        label: "BJP Office Road",
        type: "point-label",
        lineHeight: 90,
        direction: "right"
      },
      {
        id: "Shree Kamalam, BJP Office",
        yaw: "96deg",
        pitch: "-6deg",
        label: "Shree Kamalam, BJP Office",
        type: "point-label",
        lineHeight: 90,
      },
      {
        id: "Juna Koba Metro Station",
        yaw: "17deg",
        pitch: "-8deg",
        label: "Juna Koba Metro Station",
        type: "point-label",
        lineHeight: 90,
        direction: "right"
      },
      {
        id: "Shri Mahavir Jain Kendra",
        yaw: "20deg",
        pitch: "-5deg",
        label: "Shri Mahavir Jain Kendra",
        type: "point-label",
        lineHeight: 240,
        direction: "right"
      },
      {
        id: "Digambar Jain Temple",
        yaw: "22deg",
        pitch: "-3deg",
        label: "Digambar Jain Temple",
        type: "point-label",
        lineHeight: 260,
        direction: "right"
      },
      {
        id: "Koba Circle",
        yaw: "25deg",
        pitch: "-1deg",
        label: "Koba Circle",
        type: "point-label",
        lineHeight: 150,
      },
       {
        id: "Tapovan Sanskarpith",
       yaw: "41deg",
        pitch: "-2deg",
        label: "Tapovan Sanskarpith",
        type: "point-label",
        lineHeight: 110,
      },
      {
        id: "Tapovan Circle",
        yaw: "38deg",
        pitch: "-2deg",
        label: "Tapovan Circle",
        type: "point-label",
        lineHeight: 210,
      },
      {
        id: "S.M.S. Hospital",
        yaw: "40deg",
        pitch: "-1deg",
        label: "S.M.S. Hospital",
        type: "point-label",
        lineHeight: 150,
      },
      {
        id: "Agora Mall",
        yaw: "35deg",
        pitch: "-1deg",
        label: "Agora Mall",
        type: "point-label",
        lineHeight: 190,
        direction: "right"
      },
      {
        id: "Airport",
        yaw: "28deg",
        pitch: "0deg",
        label: "Airport",
        type: "point-label",
        lineHeight: 110,
      },
      {
        id: "Narendra Modi Stadium",
        yaw: "19deg",
        pitch: "-1deg",
        label: "Narendra Modi Stadium",
        type: "point-label",
        lineHeight: 110,
        direction: "right"
      },
      {
        id: "SMVS - Swaminarayan Temple",
        yaw: "170deg",
        pitch: "0deg",
        label: "SMVS - Swaminarayan Temple",
        type: "point-label",
        lineHeight: 90,
      },
      {
        id: "DPS School",
        yaw: "70deg",
        pitch: "-2deg",
        label: "DPS School",
        type: "point-label",
        lineHeight: 90,
      },
      {
        id: "Annapurana Dham",
        yaw: "65deg",
        pitch: "-1deg",
        label: "Annapurana Dham",
        type: "point-label",
        lineHeight: 110,
      },
    ],
  },
  floor_5: {
    name: "Floor 5",
    panorama: "/images/Floor_5.jpg",
    thumbnail: "/images/thumbnail/Floor_5.jpg",
    defaultYaw: "180deg",
    defaultPitch: "0deg",
    hotspots: [
      // {
      //   id: "to-locality_view",
      //   yaw: "10deg",
      //   pitch: "15deg",
      //   label: "Locality View",
      //   target: "locality_view",
      //   type: "drone"
      // },
      // {
      //   id: "to-site_view",
      //   yaw: "-10deg",
      //   pitch: "10deg",
      //   label: "Site View",
      //   target: "site_view",
      //   type: "drone"
      // },
      // {
      //   id: "to-floor_8",
      //   yaw: "-10deg",
      //   pitch: "-30deg",
      //   label: "Floor 8",
      //   target: "floor_8",
      //   type: "drone"
      // },
      // {
      //   id: "to-floor_12",
      //   yaw: "-30deg",
      //   pitch: "-20deg",
      //   label: "Floor 12",
      //   target: "floor_12",
      //   type: "drone"
      // },
      // {
      //   id: "to-kamalam_view",
      //   yaw: "95deg",
      //   pitch: "0deg",
      //   label: "Kamalam View",
      //   target: "kamalam_view",
      //   type: "drone"
      // },
    ],
  },
  floor_8: {
    name: "Floor 8",
    panorama: "/images/Floor_8.jpg",
    thumbnail: "/images/thumbnail/Floor_8.jpg",
    defaultYaw: "180deg",
    defaultPitch: "0deg",
    hotspots: [
      // {
      //   id: "to-locality_view",
      //   yaw: "20deg",
      //   pitch: "30deg",
      //   label: "Locality View",
      //   target: "locality_view",
      //   type: "drone"
      // },
      // {
      //   id: "to-site_view",
      //   yaw: "-10deg",
      //   pitch: "25deg",
      //   label: "Site View",
      //   target: "site_view",
      //   type: "drone"
      // },
      // {
      //   id: "to-floor_5",
      //   yaw: "-10deg",
      //   pitch: "-15deg",
      //   label: "Floor 5",
      //   target: "floor_5",
      //   type: "drone"
      // },
      // {
      //   id: "to-floor_12",
      //   yaw: "-30deg",
      //   pitch: "15deg",
      //   label: "Floor 12",
      //   target: "floor_12",
      //   type: "drone"
      // },
      // {
      //   id: "to-kamalam_view",
      //   yaw: "95deg",
      //   pitch: "0deg",
      //   label: "Kamalam View",
      //   target: "kamalam_view",
      //   type: "drone"
      // },
    ],
  },
  floor_12: {
    name: "Floor 12",
    panorama: "/images/Floor_12.jpg",
    thumbnail: "/images/thumbnail/Floor_12.jpg",
    defaultYaw: "180deg",
    defaultPitch: "0deg",
    hotspots: [
      // {
      //   id: "to-locality_view",
      //   yaw: "20deg",
      //   pitch: "10deg",
      //   label: "Locality View",
      //   target: "locality_view",
      //   type: "drone"
      // },
      // {
      //   id: "to-site_view",
      //   yaw: "-10deg",
      //   pitch: "0deg",
      //   label: "Site View",
      //   target: "site_view",
      //   type: "drone"
      // },
      // {
      //   id: "to-floor_5",
      //   yaw: "-10deg",
      //   pitch: "-30deg",
      //   label: "Floor 5",
      //   target: "floor_5",
      //   type: "drone"
      // },
      // {
      //   id: "to-floor_8",
      //   yaw: "-30deg",
      //   pitch: "-15deg",
      //   label: "Floor 8",
      //   target: "floor_8",
      //   type: "drone"
      // },
      // {
      //   id: "to-kamalam_view",
      //   yaw: "95deg",
      //   pitch: "0deg",
      //   label: "Kamalam View",
      //   target: "kamalam_view",
      //   type: "drone"
      // },
    ],
  },
  kamalam_view: {
    name: "Kamalam View",
    panorama: "/images/Kamalam_View.jpg",
    thumbnail: "/images/thumbnail/Kamalam_View.jpg",
    defaultYaw: "-20deg",
    defaultPitch: "0deg",
    hotspots: [
      // {
      //   id: "to-site",
      //   polygon: [
      //     ["-6deg", "-7deg"], //bottom right
      //     ["-4deg", "-7deg"],
      //     ["9deg", "-48deg"],
      //     ["-9deg", "-50deg"],
      //   ],
      //   svgStyle: {
      //     fill: "rgb(152, 146, 139)",
      //     stroke: "rgb(183, 172, 160)",
      //     strokeWidth: 3,
      //   },
      //   type: "polygon",
      // },
      {
        id: "to-site_view_1",
        yaw: "-2.5deg",
        pitch: "-6deg",
        label: "Shreem Arise",
        target: "site_view",
        type: "point-label",
        lineHeight: 150,
        fixed: true
      },
      // {
      //   id: "to-site_view",
      //   yaw: "-2.5deg",
      //   pitch: "-40deg",
      //   label: "Site View",
      //   target: "site_view",
      //   type: "arrow"
      // },
      // {
      //   id: "to-site_view_2",
      //   yaw: "-3deg",
      //   pitch: "-30deg",
      //   label: "Site View",
      //   target: "site_view",
      //   type: "arrow"
      // },
      // {
      //   id: "to-site_view_3",
      //   yaw: "-3.5deg",
      //   pitch: "-20deg",
      //   label: "Site View",
      //   target: "site_view",
      //   type: "arrow"
      // },
      // {
      //   id: "to-site_view_4",
      //   yaw: "-4.3deg",
      //   pitch: "-12deg",
      //   label: "Site View",
      //   target: "site_view",
      //   type: "arrow"
      // },
      {
        id: "Shree Kamalam, BJP Office",
        yaw: "-30deg",
        pitch: "-30deg",
        label: "Shree Kamalam, BJP Office",
        type: "point-label",
        lineHeight: 110,
      },
      {
        id: "PDPU",
        yaw: "-40deg",
        pitch: "-1deg",
        label: "PDPU",
        type: "point-label",
        lineHeight: 140,
      },
      {
        id: "Koba Metro Station",
        yaw: "-22deg",
        pitch: "-4deg",
        label: "Koba Metro Station",
        type: "point-label",
        lineHeight: 90,
      },
      {
        id: "Mahaveer Jain Temple",
        yaw: "-26deg",
        pitch: "-3deg",
        label: "Mahaveer Jain Temple",
        type: "point-label",
        lineHeight: 130,
      },
      {
        id: "Gift City",
        yaw: "-35deg",
        pitch: "-1deg",
        label: "Gift City",
        type: "point-label",
        lineHeight: 90,
      },
      {
        id: "Police Pared Groud",
        yaw: "20deg",
        pitch: "-2deg",
        label: "Police Pared Groud",
        type: "point-label"
      },
      {
        id: "Riverfront Bridge",
        yaw: "38deg",
        pitch: "-2deg",
        label: "Riverfront Bridge",
        type: "point-label"
      },
      {
        id: "Raksha Shakti Circle",
        yaw: "-105deg",
        pitch: "0deg",
        label: "Raksha Shakti Circle",
        type: "point-label",
        lineHeight: 90,
      },
      {
        id: "Koba Circle",
        yaw: "73deg",
        pitch: "-1deg",
        label: "Koba Circle",
        type: "point-label",
        lineHeight: 230,
      },
      {
        id: "Tapovan Circle",
        yaw: "80deg",
        pitch: "-1deg",
        label: "Tapovan Circle",
        type: "point-label",
        lineHeight: 100,
      },
      {
        id: "Agora Mall",
        yaw: "88deg",
        pitch: "-1deg",
        label: "Agora Mall",
        type: "point-label",
        lineHeight: 70,
      },
      {
        id: "Airport",
        yaw: "77deg",
        pitch: "0deg",
        label: "Airport",
        type: "point-label",
        lineHeight: 130,
      },
      {
        id: "Narendra Modi Stadium",
        yaw: "100deg",
        pitch: "0deg",
        label: "Narendra Modi Stadium",
        type: "point-label",
        lineHeight: 90,
      },
    ],
  },
};

export const exteriorTourOrder = ["site_view", "locality_view", "floor_5", "floor_8", "floor_12", "kamalam_view"];

export const brochure = "/images/Brochure.pdf";

export const videos = [
  {
    id: "site",
    title: "Overall Site Video",
    thumbnail: "/images/Project_Video_Thumbnail.png",
    src: "/images/Project_Video.mp4",
  },
  {
    id: "sample-house",
    title: "Sample House Video",
    thumbnail: "/images/Sample_House_Video_Thumbnail.png",
    src: "/images/Sample_House_Video.mp4",
  },
];

export const photoAlbum = [
  "/images/album/01 SIDE VIEW.jpg",
  "/images/album/02 FRONT VIEW.jpg",
  "/images/album/11 EVENING GARDEN VIEW.jpg",
  "/images/album/13 GARDEN VIEW.jpg",
  "/images/album/16 THEATER VIEW.jpg",
  "/images/album/17 YOGA VIEW.jpg",
  "/images/album/19 GARDEN VIEW EVENING.jpg",
  "/images/album/20 BIRD VIEW.jpg",
  "/images/album/21 BOX CRICKET VIEW.jpg",
  "/images/album/22 AMENITIES VIEW.jpg",
  "/images/album/23 GATE VIEW EVENING.jpg"
];